import React from 'react'
import './auth.styles.scss'
import ndpcLogo from '../../assets/images/ndpc-logo.jpg'

const AuthTemplate = (props) => {
    return (
        <div className="auth">
            <header>
                <img className="brand-logo" src={ndpcLogo} alt="Niger Delta Peace Coalition" />
                <h1>Niger Delta Peac Coalition - Admin</h1>
            </header>
            {props.children}
            <footer>
                <ul>
                    <li>
                        <a rel="noopener noreferrer" href="https://epicescapetour.com" >Main Site</a>
                    </li>
                </ul>
                <p>© 2026 Niger Delta Peac Coalition. All rights reserved.</p>
            </footer>
        </div>
    )
}

export default AuthTemplate
